import type { ReactNode } from "react"

import { StickySectionHeader } from "@/components/shared/sticky-section-header"

interface ReportingSectionHeaderProps {
	icon?: ReactNode
	title: string
	count?: number
}

export const ReportingSectionHeader = ({
	icon,
	title,
	count,
}: ReportingSectionHeaderProps) => {
	return (
		<StickySectionHeader>
			<div className="flex items-center gap-3">
				{icon}
				<span>{title}</span>
				{count !== undefined && (
					<span className="text-xs font-normal text-gray-500">{count}</span>
				)}
			</div>
		</StickySectionHeader>
	)
}
